// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"a9af53cd","425":"dbf97cf2","474":"20e7d0c3","495":"cdf780bf","790":"e0593308"}[chunkId] + ".chunk.js";
};